// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__zs_y_","colMin":"styles_colMin__1XrcG"};